module.exports = __webpack_public_path__ + "static/media/logo-cellman.9cbfb7ac.svg";